/* ControlRunsPage — §55-56 */
import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { controlApi } from "../lib/controlApi";
import { ChevronLeft, Loader2, CheckCircle2, XCircle, AlertTriangle } from "lucide-react";

const RUN_ICON = { completed: CheckCircle2, failed: XCircle, partial: AlertTriangle, running: Loader2 };
const RUN_COLOR = { completed: "text-emerald-600", failed: "text-red-600", partial: "text-amber-600", running: "text-nightblue" };

export default function ControlRunsPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [next, setNext] = useState(null);
  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [r, nr] = await Promise.all([controlApi.runs({ limit: 20 }), controlApi.nextRun()]);
      setItems(r.items || []); setNext(nr);
    } catch { /* noop */ } finally { setLoading(false); }
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div className="p-4 space-y-3" data-testid="spc-runs">
      <div className="flex items-center gap-2">
        <Link to="/control/more" className="text-textgray"><ChevronLeft className="w-4 h-4" /></Link>
        <div>
          <div className="text-[10px] uppercase tracking-[0.35em] text-textgray">Tandas</div>
          <div className="font-serif text-xl font-bold text-blueblack">Historial y próxima</div>
        </div>
      </div>
      {next && (
        <div className="border border-softblue bg-white p-4">
          <div className="text-[10px] uppercase tracking-widest text-textgray font-bold">Próxima tanda</div>
          <div className="flex items-baseline gap-2">
            <div className="font-serif text-2xl font-bold text-blueblack">
              {next.type === "morning" ? "08:00" : next.type === "afternoon" ? "15:00" : "20:00"}
            </div>
            <div className="text-xs text-textgray">en {Math.floor(next.in_minutes / 60)}h {next.in_minutes % 60}m</div>
          </div>
          {next.provisional_candidates > 0 && (
            <div className="text-[11px] text-textgray mt-1">~{next.provisional_candidates} candidatas elegibles</div>
          )}
        </div>
      )}
      {loading ? <div className="text-center p-6"><Loader2 className="w-4 h-4 animate-spin mx-auto text-textgray" /></div> : (
        <ul className="border border-softblue bg-white divide-y divide-softblue">
          {items.map((r) => {
            const Icon = RUN_ICON[r.status] || AlertTriangle;
            const color = RUN_COLOR[r.status] || "text-slate-600";
            return (
              <li key={r.id} className="p-3 flex items-start gap-3">
                <Icon className={`w-4 h-4 mt-0.5 ${color} ${r.status === "running" ? "animate-spin" : ""}`} />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center justify-between">
                    <div className="text-sm font-bold text-blueblack">
                      {r.started_at ? new Date(r.started_at).toLocaleString("es-AR", { timeZone: "America/Argentina/Ushuaia", hour: "2-digit", minute: "2-digit", day: "2-digit", month: "2-digit" }) : "—"}
                      {" · "}{r.run_type}
                    </div>
                    <div className={`text-[10px] uppercase tracking-widest font-bold ${color}`}>{r.status}</div>
                  </div>
                  <div className="text-xs text-textgray mt-0.5">
                    Portal {r.published_count || 0}
                    {typeof r.urgent_published_count === "number" && r.urgent_published_count > 0 && ` · ${r.urgent_published_count} urgentes`}
                    {r.duration_ms && ` · ${Math.round(r.duration_ms / 100) / 10}s`}
                  </div>
                </div>
              </li>
            );
          })}
          {items.length === 0 && <li className="p-6 text-center text-textgray text-xs">Sin tandas registradas.</li>}
        </ul>
      )}
    </div>
  );
}
